<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.invoiceNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái thanh toán' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.complete"
                    placeholder="Vui lòng chọn"
                    @change="selectChange(searchParams.complete)"
                  >
                    <el-option
                      v-for="item in isCompleteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="searchParams.date" mode="date" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo hình thức thanh toán theo hóa đơn` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              dom-layout="scroll"
              class="agGrid"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <p style="word-break: break-word">
            Hiển thị theo khách sạn: Mỗi khách sạn hiển thị một bảng dữ liệu
            theo các trường thông tin sau:
          </p>
          <ul class="annotate-container">
            <li>Số hóa đơn: Hiển thị số hóa đơn</li>
            <li>Ngày tháng: Ngày thực hiện giao dịch. Format: DDMMYYYY</li>
            <li>Số tiền: Số tiền trên hóa đơn</li>
            <li>Đã đặt cọc: số tiền khách đã đặt cọc trong phòng</li>
            <li>
              Đã thanh toán: Số tiền thanh toán các dịch vụ hoặc thanh toán thêm
              = Đã đặt cọc + Tiền thanh toán thêm
            </li>
            <ul>
              <li>Hiển thị chia ra các cột phương thức thanh toán</li>
            </ul>
            <li>
              Còn cần thanh toán: là số tiền còn lại khách cần phải thanh toán :
              Số tiền - Đã thanh toán
            </li>
            <li>
              Tổng: Mỗi khách sạn có 1 dòng tổng theo các cột (Số tiền, Phương
              thức thanh toán, Đã đặt cọc, Đã thanh toán, Còn cần thanh toán)
            </li>
            <li>Tổng cộng: tổng của tất cả các khách sạn theo cột</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from './components/DownloadBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import NoteDialog from './components/NoteDialog.vue'

import { getAllHotel } from '@/api/hotel'
import {
  getTransactionSummaryReport,
  getTransactionSummaryReportExcel
} from '@/api/report_service/datntReport'
import { formatVND } from '@/utils/commonUtils'

export default {
  components: { CalendarRange, DownloadBtn, NoteDialog },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      // date
      searchParams: {
        invoiceNum: null,
        complete: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        hotelIds: [],
        recode: null
      },
      defaultSearchParams: {
        invoiceNum: null,
        complete: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null,
        hotelIds: [],
        recode: null
      },

      // data for search
      hotelList: [],
      isCompleteOptions: [
        {
          label: 'Chọn tất cả',
          value: null
        },
        {
          label: 'Đã thanh toán hết',
          value: true
        },
        {
          label: 'Chưa thanh toán hết',
          value: false
        }
      ],

      // grid
      columns: [
        {
          headerName: 'Số hóa đơn',
          field: 'invoice_num',
          sortable: false,
          headerClass: 'header-row-span-2',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Recode',
          field: 'recode',
          sortable: false,
          headerClass: 'header-row-span-2',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          sortable: false,
          headerClass: 'header-row-span-2',
          minWidth: 120,
          maxWidth: 150
        },
        // {
        //   headerName: 'Ngày tháng',
        //   field: '',
        //   headerClass: 'header-row-span-2'
        // },
        {
          headerName: 'Số tiền',
          // field: 'money',
          // valueGetter: params => formatVND(params.data.money, 'VND '),
          cellRenderer: params => formatVND(params.data.money, null),
          sortable: false,
          cellClass: 'ag-cell-right',
          headerClass: 'header-row-span-2',
          minWidth: 120
        },
        {
          headerName: 'Đã đặt cọc',
          field: 'deposit',
          cellRenderer: params => formatVND(params.data.deposit, null),
          cellClass: 'ag-cell-right',
          sortable: false,
          headerClass: 'header-row-span-2',
          minWidth: 120
        },
        {
          headerName: 'Đã thanh toán',
          headerClass: 'header-cell-center',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'transfer',
              sortable: false,
              cellRenderer: params => formatVND(params.data.transfer, null),
              cellClass: 'ag-cell-right',
              minWidth: 120
            },
            {
              headerName: 'Tiền mặt',
              sortable: false,
              field: 'cash',
              cellRenderer: params => formatVND(params.data.cash, null),
              cellClass: 'ag-cell-right',
              minWidth: 120
            },
            {
              headerName: 'Thẻ',
              sortable: false,
              field: 'card',
              cellRenderer: params => formatVND(params.data.card, null),
              cellClass: 'ag-cell-right',
              minWidth: 120
            },
            {
              headerName: 'Công nợ',
              sortable: false,
              field: 'debt',
              cellRenderer: params => formatVND(params.data.debt, null),
              cellClass: 'ag-cell-right',
              minWidth: 120
            },
            {
              headerName: 'FOC',
              sortable: false,
              field: 'foc',
              cellRenderer: params => formatVND(params.data.foc, null),
              headerClass: 'last-header-cell-group',
              cellClass: 'ag-cell-right',
              minWidth: 120
            }
          ]
        },
        {
          headerName: 'Còn cần thanh toán',
          sortable: false,
          field: 'surplus',
          cellRenderer: params => formatVND(params.data.surplus, null),
          cellClass: 'ag-cell-right',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          minWidth: 120
        }
      ],
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  async mounted() {
    await this.getListHotel()
    await this.fnGetTransactionSummaryReport()
  },

  methods: {
    onSearch() {
      this.fnGetTransactionSummaryReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetTransactionSummaryReport()
    },

    selectChange(selectedValue) {},

    // handle api call
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    exportExcel() {
      const query = {
        invoiceNum: this.searchParams.invoiceNum,
        dateFrom: this.searchParams.date.start,
        dateTo: this.searchParams.date.end,
        complete: this.searchParams.complete,
        hotelIds: this.searchParams.hotelIds
      }
      getTransactionSummaryReportExcel(query).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'tong_hop_giao_dich_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },
    async fnGetTransactionSummaryReport() {
      try {
        const query = {
          invoiceNum: this.searchParams.invoiceNum,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end,
          complete: this.searchParams.complete,
          hotelIds: this.searchParams.hotelIds,
          recode: this.searchParams.recode
        }

        const res = await getTransactionSummaryReport(query)
        this.rows = res.data.map(item => {
          if (item?.date) {
            return {
              ...item,
              isFullWidthRow: true,
              name: item.date
            }
          }
          if (item?.hotel_name) {
            return {
              ...item,
              isFullWidthRow: true,
              name: item.hotel_name
            }
          }
          if (item?.total_money) {
            return {
              money: item.total_money,
              deposit: item.total_deposit,
              transfer: item.total_transfer,
              cash: item.total_cash,
              card: item.total_card,
              debt: item.total_debt,
              foc: item.total_foc,
              surplus: item.total_surplus,
              invoice_num: 'Tổng'
            }
          }
          if (item?.total_date) {
            return {
              invoice_num: 'Tổng cộng',
              transfer: item.bank_transfer,
              ...item
            }
          }
          return item
        })

        // this.pinnedBottomRowData = [{ ...this.rows.pop() }]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>
